import * as React from 'react';
import { MaskedInput } from '@cian/ui-kit';
export var TimeInput = function TimeInput(_ref) {
  var disabled = _ref.disabled,
      invalid = _ref.invalid,
      inputRef = _ref.inputRef,
      onChange = _ref.onChange,
      size = _ref.size,
      value = _ref.value;
  var handleChange = React.useCallback(function (event, value) {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(MaskedInput, {
    mask: "99:99",
    maskPlaceholder: "",
    inputRef: inputRef,
    name: "time",
    onChange: handleChange,
    value: value,
    disabled: disabled,
    invalid: invalid,
    size: size
  });
};